import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deliv',
  templateUrl: './deliv.component.html',
  styleUrls: ['./deliv.component.scss']
})
export class DelivComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
